import { render, staticRenderFns } from "./ProductBannerTheme0.vue?vue&type=template&id=71871339&scoped=true"
import script from "./ProductBannerTheme0.vue?vue&type=script&lang=js"
export * from "./ProductBannerTheme0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71871339",
  null
  
)

export default component.exports